// extracted by mini-css-extract-plugin
module.exports = {"back":"Service-module--back--3bfw8","ServiceMenu":"Service-module--ServiceMenu--dtIN8"};